import React, { useState } from "react";
import SideMenuData from "./side-menu-data";
import { Grid, Badge, IconButton } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Menu from "@mui/material/Menu";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import logo from "./../../../assets/images/logo.png";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import BookIcon from "@mui/icons-material/Book";
import ForumIcon from "@mui/icons-material/Forum";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PsychologyIcon from "@mui/icons-material/Psychology";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import { Button } from "@mui/material";
import ProfileImg from "./../../../assets/images/ProfileImage.png";
import HistoryIcon from "@mui/icons-material/History";
import { IoLogOutSharp } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import GroupIcon from "@mui/icons-material/Group";
import Model from "./../model";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import GroupsIcon from '@mui/icons-material/Groups';
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
    backgroundColor: "white",
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  backgroundColor: "white",
  border: "1px solid #A6A6A6",
  [theme.breakpoints.up("sm")]: {
    // marginLeft: theme.spacing(3),
    width: "500px",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "450px",
    },
  },
}));

export const SideMenu = (props) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [popupOpen, setPopupOpen] = React.useState(false);
  let [pagesShow, setPagesShow] = React.useState(false);
  const location = useLocation();
  let CurrentPagePath = location.pathname;
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobileView = useMediaQuery(theme.breakpoints.down("lg"));

  let NotificationData = [
    {
      name: "Samantha aryton",
      tag: "Complate",
      message: "your Lorem ipsum dolor sit a...",
    },
    {
      name: "Nataliya law",
      tag: "Congratulate",
      message: "Lorem ipsum dolor sit a...",
      title: "purchase your ",
    },
    {
      name: "Samantha aryton",
      tag: "Complate",
      message: "your Lorem ipsum dolor sit a...",
    },
    {
      name: "Nataliya law",
      tag: "Congratulate",
      message: "Lorem ipsum dolor sit a...",
      title: "purchase your ",
    },
  ];
  return (
    <>
      <div>
        <Grid container>
          <Grid item xs={12} md={2}>
            <SideMenuData />
          </Grid>
          <Grid item xs={12} lg={10}>
            <div className="tutot-right-side-container">
              <div className="tutor-dashboard-page-header-container">
                <div className="tutor-dashboard-page-header-content-wrapper">
                  <div>
                    {isMatch ? (
                      <div>
                        <IconButton
                          onClick={() => {
                            setIsDrawerOpen(true);
                          }}
                        >
                          <MenuIcon />
                        </IconButton>
                      </div>
                    ) : (
                      <div> </div>
                    )}

                    <Drawer
                      anchor="left"
                      open={isDrawerOpen}
                      onClose={handleDrawerClose}
                    >
                      <div>
                        <div className="tutor-panel-sider-content-wraper">
                          <div className="drawer-header-main">
                            <img src={logo} alt="logo" width="100px" />
                            <IconButton
                              onClick={() => {
                                handleDrawerClose();
                              }}
                              className="app-bar-component-drawer-close-btn"
                            >
                              <CloseIcon />
                            </IconButton>
                          </div>
                          <div className="side-menu-data-list-main">
                            <ul className="side-menu-ul">
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath ===
                                    "/student-panel/dashboard"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/student-panel/dashboard");
                                  }}
                                >
                                  <DashboardIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    dashboard
                                  </span>
                                </Button>
                              </li>

                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath ===
                                    "/student-panel/my-profile"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/student-panel/my-profile");
                                  }}
                                >
                                  <PersonIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    my profile
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath ===
                                      "/student-panel/my-courses" ||
                                    CurrentPagePath ===
                                      "/student-panel/my-courses/view" ||
                                    CurrentPagePath ===
                                      "/student-panel/my-courses/live"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/student-panel/my-courses");
                                  }}
                                >
                                  <BookIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    my courses
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath ===
                                      "/student-panel/courses-history" ||
                                    CurrentPagePath ===
                                      "/student-panel/courses-history/view"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/student-panel/courses-history");
                                  }}
                                >
                                  <HistoryIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    courses History
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/student-panel/chat"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/student-panel/chat");
                                  }}
                                >
                                  <ForumIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    chat
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath ===
                                      "/student-panel/notifications" ||
                                    CurrentPagePath ===
                                      "/student-panel/notifications/view"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/student-panel/notifications");
                                  }}
                                >
                                  <NotificationsActiveIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    notifications
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath ===
                                    "/student-panel/my-wallet"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/student-panel/my-wallet");
                                  }}
                                >
                                  <AccountBalanceWalletIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    my wallet
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath ===
                                      "/student-panel/invoice" ||
                                    CurrentPagePath ===
                                      "/student-panel/invoice/view"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/student-panel/invoice");
                                  }}
                                >
                                  <PriceChangeIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    invoice
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath ===
                                    "/student-panel/invite-friends"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/student-panel/invite-friends");
                                  }}
                                >
                                  <GroupIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    invite friends
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath ===
                                      "/student-panel/dispute" ||
                                    CurrentPagePath ===
                                      "/student-panel/dispute/create"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/student-panel/dispute");
                                  }}
                                >
                                  <PsychologyIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    dispute
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath ===
                                      "/student-panel/assignment" ||
                                    CurrentPagePath ===
                                      "/student-panel/assignment/view" ||
                                    CurrentPagePath ===
                                      "/student-panel/assignment/create"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/student-panel/assignment");
                                  }}
                                >
                                  <AssignmentIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    assignment
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath ===
                                      "/student-panel/attendance"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/student-panel/attendance");
                                  }}
                                >
                                  <GroupsIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                  attendance
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath ===
                                      "/student-panel/result" ||
                                    CurrentPagePath ===
                                      "/student-panel/result/view"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/student-panel/result");
                                  }}
                                >
                                  <FactCheckIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    result
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath ===
                                      "/student-panel/leave-request" ||
                                    CurrentPagePath ===
                                      "/student-panel/leave-request/create" ||
                                    CurrentPagePath ===
                                      "/student-panel/leave-request/view"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/student-panel/leave-request");
                                  }}
                                >
                                  <LiveHelpIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    leave request
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath ===
                                    "/student-panel/transaction-history"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate(
                                      "/student-panel/transaction-history"
                                    );
                                  }}
                                >
                                  <PointOfSaleIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    transaction history
                                  </span>
                                </Button>
                              </li>
                              <br />
                            </ul>
                          </div>
                          <div className="first-tutor-panel-sider-log-out-container">
                            <Button
                              variant="text"
                              className="logout-button"
                              onClick={() => {
                                navigate("/");
                                window.location.reload();
                              }}
                            >
                              <span>Logout</span>
                              <IoLogOutSharp className="side-menu-icon" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Drawer>
                  </div>

                  <div className="side-menu-header">
                    <div>
                      {isMobileView ? (
                        <div> </div>
                      ) : (
                        <Search>
                          <SearchIconWrapper>
                            <SearchIcon />
                          </SearchIconWrapper>
                          <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ "aria-label": "search" }}
                          />
                        </Search>
                      )}
                    </div>
                    <div className="tutor-dashboard-page-header-content-wrapper-profile-logo">
                      <div>
                        {props.purchseIcon && (
                          <IconButton
                            id="basic-button"
                            aria-controls={open ? "basic-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                            onClick={props.cartHandler}
                          >
                            <Badge
                              badgeContent={4}
                              overlap="circular"
                              color="error"
                              className="badge-color"
                            >
                              <ShoppingCartIcon
                                style={{ color: "#663399", fontSize: "30px" }}
                              />
                            </Badge>
                          </IconButton>
                        )}
                        <IconButton
                          id="basic-button"
                          aria-controls={open ? "basic-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                          onClick={handleClick}
                        >
                          <Badge
                            badgeContent={4}
                            overlap="circular"
                            color="error"
                            className="badge-color"
                          >
                            <NotificationsIcon
                              style={{ color: "#663399", fontSize: "30px" }}
                            />
                          </Badge>
                        </IconButton>
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                        >
                          <div className="first-tutor-doashboard-notification-wraper">
                            <Button
                              variant="text"
                              className="notification-clear-all-button"
                            >
                              <CloseIcon />
                              <p>Clear All</p>
                            </Button>
                            <div className="side-menu-notification-main">
                              {NotificationData.map(
                                (notificationValue, notificationIndex) => {
                                  return (
                                    <div
                                      key={notificationIndex}
                                      onClick={() => setPopupOpen(true)}
                                    >
                                      {notificationValue.tag === "Complate" ? (
                                        <div className="side-menu-notification-card">
                                          <span className="side-menu-notification-heading">
                                            {notificationValue.name}{" "}
                                          </span>
                                          <span className="side-menu-notification-title">
                                            {notificationValue.tag}{" "}
                                          </span>
                                          <span className="side-menu-notification-heading">
                                            {notificationValue.message}
                                          </span>
                                          <p className="side-menu-notification-date">
                                            JAN 5, 2022
                                          </p>
                                        </div>
                                      ) : (
                                        <div
                                          className="side-menu-notification-card"
                                          onClick={() => setPopupOpen(true)}
                                        >
                                          <span className="side-menu-notification-title">
                                            {notificationValue.tag}{" "}
                                          </span>
                                          <span className="side-menu-notification-heading">
                                            {notificationValue.name}{" "}
                                          </span>
                                          <span className="side-menu-notification-title">
                                            {notificationValue.title}{" "}
                                          </span>
                                          <span className="side-menu-notification-heading">
                                            {notificationValue.message}
                                          </span>
                                          <p className="side-menu-notification-date">
                                            JAN 5, 2022
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </div>
                        </Menu>
                      </div>
                      <p className="side-menu-header-username">Gmits classes</p>
                      <img
                        src={ProfileImg}
                        alt="Profile"
                        className="side-menu-header-profile-image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  props.chat
                    ? "side-menu-children-chat-data"
                    : "side-menu-children-data"
                }
              >
                {props.children}
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <Model
        modelTitle="Notification"
        width="md"
        onClose={() => setPopupOpen(false)}
        open={popupOpen}
        buttonHide={true}
      >
        <div>
          <div className="notification-model-header">
            <div>
              <span className="notification-model-username">
                Samantha aryton
              </span>
              <span className="notification-model-complete-title">
                Complate
              </span>
              <span className="notification-model-username">
                your Lorem ipsum dolor sit
              </span>
            </div>
            <p className="notification-model-date">JAN 5, 2022</p>
          </div>
          <p className="notification-model-description">
            Curabitur tincidunt eros in est aliquet, vel congue ex egestas.
            <br />
            <br />
            Nullam id nibh vitae dui euismod cursus vitae elementum tortor.
            Fusce congue faucibus nulla vel semper. Donec ac interdum ipsum.
            <br />
            <br />
            Proin cursus sem mi, sit amet tempor diam pulvinar cursus. Ut ac
            tempus risus. In ac metus ac metus mattis fermentum id in dolor.
            <br />
            <br />
            Fusce sollicitudin vitae ante in finibus. Maecenas gravida nibh et
            nulla fringilla consequat sit amet vehicula massa. Aliquam in tellus
            pharetra, ultrices est in, sagittis elit.
            <br />
            <br /> Etiam eget diam vel nulla congue viverra. Nullam et iaculis
            nisi, sit amet mollis risus.
          </p>
        </div>
      </Model>
    </>
  );
};

export default SideMenu;
